<template>
  <div id="adminCrmImage">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">Community</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Immagini</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <h1>Immagini</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
                  <div class="row align-btns" style="width: 85%;">
                    <div class="col-lg-12">
                     <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewImages"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                  </div>           
              </div>
            <div class="card-body nopadding">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableImage"
                :onCheck="onTableCheckImage"
                :onCheckAll="onTableCheckImage"
                :onUncheck="onTableCheckImage"
                :onUncheckAll="onTableCheckImage"
                ref="tableImage"
                :results="tableImageResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabImageDetail" role="tabpanel" style="box-shadow:none;">
            <div class="card-body" style="padding:30px;">

              <div class="row">
                  <div class="col-12">
                  <!-- TAB IMAGES -->
                    <div class="tab-pane" id="tabDetailAttributeImages" role="tabpanel" style="padding-left: 0px;padding-right: 0px;box-shadow:none;">
                      <div class="row div-row-img-item">
                        <div class="col-9 align-self-center">
                          <div class="row div-row-img-item">
                            <div class="col-5 align-self-center">
                             <br />
                              <button
                                class="btn btn-primary"
                                @click="selectImageExist(detailImageData.id, true)"
                              >
                                SELEZIONA
                              </button>
                              <label class="label-name">{{detailImageData.imgName}}</label>
                            </div>
                            <div class="col-2 align-self-center">
                              <label>Anteprima</label><br />
                              <a class="img" :href="detailImageData.img"><img style="width: 100px;" :src="detailImageData.img" /></a>
                            </div>
                            <div class="col-4 align-self-center">
                              <label style="margin-top: 15px;" v-if="detailImageData.weight != '0 bytes'">
                                <i class="fa fa-balance-scale fa-stack" aria-hidden="true"></i> {{ detailImageData.weight }}
                              </label><br>
                              <label v-if="detailImageData.width>0 || detailImageData.width!=0">
                                <i class="fa fa-arrows-alt fa-stack" aria-hidden="true"></i>{{ detailImageData.width }} x {{ detailImageData.height }} pixel
                              </label>
                            </div>
                            <div class="col-1 align-self-center">
                              <i
                                class="fa fa-trash btn btn-danger"
                                style="color:#fff;"
                                @click="deleteImage(true, detailImageData.id)"
                              ></i>
                            </div> 
                          </div>
                        </div>
                        <div class="col-3 align-self-center">
                          <label
                            for="imgPrincipal"
                            class="custom-file-upload"
                            v-cloak
                            @drop.prevent="onChangeImagePrincipal"
                            @dragover.prevent
                          >
                            SFOGLIA / UPLOAD AREA
                          </label>
                          <input
                            type="file"
                            id="imgPrincipal"
                            name="imgPrincipal"
                            @change="onChangeImagePrincipal"
                          />
                        </div>
                      </div>
                         <div class="row div-row-img-item">
                            <div class="col-12">
                             <br />
                              <button
                                class="btn btn-primary"
                                id="btn-converttoWebP"
                                @click="convertToWebP(detailImageData.id, true,detailImageData.imgBase64,detailImageData.image_title,detailImageData.imgName)"
                              >
                                CONVERTI IN WEBP
                              </button>
                            </div> </div>
                    </div>
                    <!-- modal immagini -->
                    <div
                      class="modal"
                      id="modalImageExistFolder"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="myModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialo popup" role="document">
                        <div class="modal-content modal">
                          <div class="modal-header text-center">
                             <div class="row" style="width:100%;">
                              <div class="col-4 text-left"> 
                                <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagini</h2>
                              </div>
                              <div class="col-2 text-right">
                              <select class="form-control" id="month" name="month" @change="Search()">
                                <option value="">Mese</option>
                                <option value="01">Gennaio</option>
                                <option value="02">Febbraio</option>
                                <option value="03">Marzo</option>
                                <option value="04">Aprile</option>
                                <option value="05">Maggio</option>
                                <option value="06">Giugno</option>
                                <option value="07">Luglio</option>
                                <option value="08">Agosto</option>
                                <option value="09">Settembre</option>
                                <option value="10">Ottobre</option>
                                <option value="11">Novembre</option>
                                <option value="12">Dicembre</option>
                              </select>
                            </div>
                            <div class="col-2 text-right">
                              <select class="form-control" id="year" name="year" @change="Search()">
                                <option value="">Anno</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                              </select>
                            </div>
                              <div class="col-4"> 
                                <input type="text" class="form-control" id="search" required="required" name="search" placeholder="Cerca" @keyup="Search()"/> 
                              </div>
                            </div>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body mx-3">
                            <div class="md-form mb-5">
                              <div
                                class="row">
                            <ul class="list-group" id="ul-image" @scroll="handleScroll">
                                <li class="listLi" v-for="arrayAllImagesExistFolders in arrayAllImagesExistFolder" v-bind:key="arrayAllImagesExistFolders.id" @click="
                                  selectReplaceImageExist(
                                  idImageSelectedToReplaceImage,
                                  arrayAllImagesExistFolders.imgName)" >
                                  <div class="list-group-item" :style="'cursor:pointer;position: relative;min-width:110px;min-height:110px;min-width:110px;max-width:110px;background-size:cover;background-image:url(\'' + arrayAllImagesExistFolders.img + '\')'">
                                    <div v-if="arrayAllImagesExistFolders.ext!=''" class="div-extension-img">
                                      <label>{{ arrayAllImagesExistFolders.ext }}</label>
                                    </div>
                                    <label class="labelListImage">{{ arrayAllImagesExistFolders.imgName }}</label>
                                  </div>
                                  </li> 
                              </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end modal immagini -->
                    <!-- TAB IMAGES -->
              </div></div>
              <div class="row">
                <pageDetail
                  functions="AdminSettingImage"
                  :configurations="detailImageConfiguration"
                  :jsonValue="detailImageData"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-12 text-right" style="margin-top:10px;">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="cancelNewImage"
                  ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="saveNewImage"
                  ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import Select2 from "@/components/Select2.vue";
import PageDetail from "@/components/PageDetail.vue";
export default {
  name: "adminCrmImage",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
  },
  data: function () {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      Image: dictionaryHelpers.getDictionary("Image"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      detailImageConfiguration: [],
      tableImageResult: [],
      detailImageData: {img:'',imgName:'',imgBase64:''},
      tableConfiguration: [],
      rowIdSelected:0,
      checkInsert: false,
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null },
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname,
      typePage: "photo",
      arrayListCategoriesDetail: [],
      checkAssociationCodeImage: false,
      itemImages: [],
      categoriesLanguages: [],
      arrayAllImagesExistFolder: [],
      selectedChangePrincipalImage: false,
      resultTranslatePopups: {},
      noMoreTranslate: false,
      scriptGallery: false,
      pageImage: 1,
      idImageSelectedToReplaceImage: 0,

    };
  },
  created() {
    var adminCrmImage = this;

    spinnerHelpers.show();
    adminCrmImage.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage(),
    };

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function (result) {
      adminCrmImage.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;;
      adminCrmImage.detailImageConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
      adminCrmImage.loadTable();
      
    });
  },
  methods: {

    handleScroll(){
      if($('#ul-image').scrollTop() + $('#ul-image').innerHeight() >= $('#ul-image')[0].scrollHeight) {
        this.pageImage = this.pageImage + 1;
        this.selectImageExist(this.idImageSelectedToReplaceImage, this.selectedChangePrincipalImage);
      }
    },
    Search() { 
      var adminCrmImage = this;
      adminCrmImage.pageImage = 1;
      adminSettingNews.selectImageExist(adminCrmImage.idImageSelectedToReplaceImage, adminCrmImage.selectedChangePrincipalImage);
    },

    loadTable() {
      var adminCrmImage = this;
        communityImageServices.getAll(function (result) {
         adminCrmImage.tableData = result.data;
        adminCrmImage.checkInsert = false;
        spinnerHelpers.hide();
      });
    },
    onTableCheckImage() {
      var countRowSelected = this.$refs.tableImage.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

  CheckOnlineCommunityImagesFormatter(value, row, index, field){    
        var adminCrmImage = this;  
        var html = "";

        html += '<label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom">';
        
        if(row.online){
          html += '<input type="checkbox" class="switch-input" checked="checked" onclick="adminCrmImage.__vue__.updateOnlineCheckImages(' + row.id + ')"/>';
        }else{
          html += '<input type="checkbox" class="switch-input" onclick="adminCrmImage.__vue__.updateOnlineCheckImages(' + row.id + ')"/>';
        }
        html += '<span class="switch-slider" data-on data-off></span>';
        html += '</label>';
        return html;
    },


 updateOnlineCheckImages(id){
      var adminCrmImage = this;
      var data = {
        id: id,
      };
      communityImageServices.updateOnlineCheckImages(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },

    CommunityImagesFormatter(value, row, index, field) {
      var adminCrmImage = this;
      var html = "";
      html +=
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmImage.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil"/></button>';
      html +=
        '<button class="btn btn-danger" onclick="adminCrmImage.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';

      html += "</div>";
      return html;
    },
    viewDatailInfo(id) {
      spinnerHelpers.show();
      var adminCrmImage = this;
      this.rowIdSelected = id;
      $.each(this.tableData, function (i, row) {
        if (adminCrmImage.rowIdSelected == row.id) {
            adminCrmImage.detailImageData = row;
            console.log(row);
        }
      });
      $("#btn-converttoWebP").show();
      $("#tabTable").removeClass("active");
      $("#tabImageDetail").addClass("active");
      spinnerHelpers.hide();
    },



  /* IMMAGINI */
    loadItemImages() {
      var adminCrmImage = this;
      communityImageCategoryServices.getImages(adminCrmImage.rowIdSelected, function (result) {
         /*adminCrmImage.detailImageData.img = result.data.img;
         adminCrmImage.detailImageData.imgName = result.data.imgName;*/
         adminCrmImage.detailImageData.width = result.data.width;
         adminCrmImage.detailImageData.height = result.data.height;
         adminCrmImage.detailImageData.weight = result.data.weight;

        if(!adminCrmImage.scriptGallery){
          $.getScript("https://cdn.rawgit.com/sachinchoolur/lightgallery.js/master/dist/js/lightgallery.js").done(function(){
            adminCrmImage.scriptGallery = true;
            $.getScript("https://cdn.jsdelivr.net/picturefill/2.3.1/picturefill.min.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-share.js/master/dist/lg-share.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-pager.js/master/dist/lg-pager.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-autoplay.js/master/dist/lg-autoplay.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-fullscreen.js/master/dist/lg-fullscreen.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-zoom.js/master/dist/lg-zoom.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-hash.js/master/dist/lg-hash.js");
            /*lightGallery(document.getElementById('lightgallery'));*/
            lightGallery(document.getElementById('tabDetailAttributeImages'), {
              selector : '.img'
            }); 
          });
        }
      });
    },

    deleteImage(isPrincipalImage, id) {
      var adminCrmImage = this;
      if (confirm("Sei sicuro di voler eliminare l'associazione dell'immagine?")) {
        if (isPrincipalImage) {
          var data = {
            idItem: adminCrmImage.rowIdSelected,
            imgName: "",
            imgBase64: "",
          };
            communityImageCategoryServices.updateImageName(data, function (result) {
            adminCrmImage.loadItemImages();
            notificationHelpers.success("Eliminazione avvenuta correttamente");
          });
        }
      }
    },

    convertToWebP(id, isPrincipalImage, imgBase64, image_title, imgName) {
    var adminCrmImage = this;
    if (isPrincipalImage) {
          var data = {
            id: id,
            imgName: imgName,
            imgBase64: imgBase64,
            title: image_title
          };
            communityImageServices.insertToWebP(data, function (result) {
            notificationHelpers.success("Conversione in webP avvenuta correttamente");
          });
        }
    },


    changeTitle(field, value) {
      var adminCrmImage = this;
      var titleToTitles= $("#image_title").val();
      var cleanShareTitle = titleToTitles;  
      //copy url
      var titleToUrl = $("#image_title").val(),
      cleanUrl = "";
      cleanUrl =
        "/" +
        adminCrmImage.typePage.toLowerCase() +
        "/" +
        titleToUrl
          .replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-")    
          .replace(/([\à\s])/g, "a")
          .replace(/([\á\s])/g, "a")
          .replace(/([\è\s])/g, "e")
          .replace(/([\ê\s])/g, "e")
          .replace(/([\é\s])/g, "e")
          .replace(/([\ì\s])/g, "i")
          .replace(/([\í\s])/g, "i")
          .replace(/([\ò\s])/g, "o")
          .replace(/([\ó\s])/g, "o")
          .replace(/([\ù\s])/g, "u")
          .replace(/([\ú\s])/g, "u")
          .replace(/([\ż\s])/g, "z")
          .replace(/([\ź\s])/g, "z")
         	.replace(/([\ź\s])/g, "z")
          .replace(/([\ń\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")  
          .toLowerCase();

      for (var i=0; i<100; i++){
        if (cleanUrl.includes('--')) { 
          cleanUrl = cleanUrl.replace('--', '-');
        }else{
          break;
        } 
      }
        var myString = cleanUrl;
        var stringLength = myString.length;
        var lastChar = myString.charAt(stringLength - 1);

        if (lastChar == '-') {
           var cleanUrl = myString.substring(0, myString.length - 1); 
          //  $("#link").val(cleanUrl);
        }else{
          var cleanUrl =myString;
        }
          
      if (adminCrmImage.rowIdSelected == null || $("#link").val() == "") {  
        $("#link").val(cleanUrl);
        adminCrmImage.detailImageData.link = dataHelpers.unbind(cleanUrl);
    }
  },

   
  onChangeImagePrincipal(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImagePrincipal(e.target.id, files[0].name, files[0], true);
    },
    createImagePrincipal(id, name, file, isPrincipal) {
      var adminCrmImage = this;
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        adminCrmImage.detailImageData.imgName = name;
        adminCrmImage.detailImageData.imgBase64 =  e.target.result;
        adminCrmImage.detailImageData.img =  e.target.result;

        if (adminCrmImage.rowIdSelected == 0 || adminCrmImage.rowIdSelected == ''){
            notificationHelpers.success("Aggiunta immagine correttamente, premi salva per confermare"); 
       }else{
            notificationHelpers.success("Immagine caricata"); 
       }

      };
      reader.readAsDataURL(file);
    },
    
    selectImageExist(id, isPrincipal) {
      var adminCrmImage = this;

      adminCrmImage.idImageSelectedToReplaceImage = id;
      adminCrmImage.selectedChangePrincipalImage = isPrincipal;
      var data = {
        page : adminCrmImage.pageImage,
        search : $('#modalImgBlogForm #search').val(),
        month : $('#modalImgBlogForm #month').val(),
        year : $('#modalImgBlogForm #year').val(),
      };
      pageServices.getByFile(data, function (result) {
        $("#modalImageExistFolder").modal("show");
        if(result.data.length>0){
          if(adminCrmImage.arrayAllImagesExistFolder.length == 0 || adminCrmImage.pageImage == 1){ 
            adminCrmImage.arrayAllImagesExistFolder = result.data;
            $('#ul-image').css('max-height', window.innerHeight - 200);
          }else{
            var array1 = adminCrmImage.arrayAllImagesExistFolder;
            var array2 = result.data;
            var newArray = array1.concat(array2);
            adminCrmImage.arrayAllImagesExistFolder = newArray;
          }
        }
      });
    },
    selectReplaceImageExist(id, img) {
      var adminCrmImage = this;
      var data = {
        idItem: adminCrmImage.rowIdSelected,
        imgName: img,
        imgBase64: "",
        principal: adminCrmImage.selectedChangePrincipalImage
      };

      communityImageCategoryServices.updateImageName(data, function (result) {
         $("#modalImageExistFolder").modal("hide");
         adminCrmImage.loadItemImages();
         notificationHelpers.success("Immagine aggiornata con successo");
      });
    },
    /* END IMMAGINI */

onNewImages() {
  var adminCrmImage = this;
  spinnerHelpers.show();
  this.rowIdSelected = 0;
  var sUserId = storageData.sUserId();
  adminCrmImage.detailImageData.users_id = sUserId;
  adminCrmImage.detailImageData.id = '';
  adminCrmImage.detailImageData.image_title = '';
  adminCrmImage.detailImageData.link = '';
  adminCrmImage.detailImageData.online = '';
  adminCrmImage.detailImageData.image_description = '';
  adminCrmImage.detailImageData.keywords = '';
  adminCrmImage.detailImageData.image_category_id = '';
  adminCrmImage.detailImageData.upload_datetime = '';
  adminCrmImage.detailImageData.imgName = '';
  adminCrmImage.detailImageData.imgBase64 = '';
  adminCrmImage.detailImageData.img = '';
  this.checkInsert = true;
  $("#btn-converttoWebP").hide();
  $("#tabImageDetail").addClass("active");
  $("#tabTable").removeClass("active");
  spinnerHelpers.hide();
},

  delete(id) {
       if (confirm("Sei sicuro di voler eliminare?")) {
        this.executeDeletes(id);
      }
  },

    executeDeletes(id) {
      var adminCrmImage = this;
      spinnerHelpers.show();
      communityImageServices.del(id, function () {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
        adminCrmImage.loadTable();
        window.scrollTo(0, 0);
      });
    },

    cancelNewImage() {
      spinnerHelpers.show();
      this.detailImageData = {};
      $("#tabTable").addClass("active");
      $("#tabImageDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    saveNewImage() {
      spinnerHelpers.show();
      var adminCrmImage = this;
      this.detailImageData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0) {
        this.detailImageData.id = this.rowIdSelected;
        communityImageServices.update(this.detailImageData, function (result) {
          notificationHelpers.success(adminCrmImage.updateCompleted);
          adminCrmImage.loadTable();
          $("#tabTable").addClass("active");
          $("#tabImageDetail").removeClass("active");
        });
      } else {
         communityImageServices.insertNewImages(this.detailImageData, function (result) {
          notificationHelpers.success(adminCrmImage.insertCompleted);
          if(adminCrmImage.checkInsert){
            spinnerHelpers.hide();
            var idNew = result.data.id;
            communityImageServices.getAll(function (result2) {
              adminCrmImage.tableData = result2.data;
              adminCrmImage.checkInsert = false;

              adminCrmImage.rowIdSelected = idNew;
              $.each(adminCrmImage.tableData, function (i, row) {
                if (adminCrmImage.rowIdSelected == row.id) {
                  adminCrmImage.detailImageData = row;
                }
              });
              $("#btn-converttoWebP").show();
              $("#tabTable").removeClass("active");
              $("#tabImageDetail").addClass("active");
            });

          }else{
            adminCrmImage.loadTable();
            $("#tabTable").addClass("active");
            $("#tabImageDetail").removeClass("active");
          }
        /*adminCrmImage.loadTable();
          $("#tabTable").addClass("active");
          $("#tabImageDetail").removeClass("active");*/
        });
      }
    },
  },
};
</script>
<style scoped>
.card-title-admin .card {
  background: transparent;
  border: 0px;
}
.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}

/*.align-btn {
  position: absolute;
  margin-top: 45px;
  z-index: 1000000;
}*/

.align-btns {
 position: absolute;
    z-index: 10000;
    margin-top: 10px;
}

.span {
  position: absolute;
  margin-top: 75px;
}

/* popup image */

#ul-image{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
.listLi {
  list-style: none;
  text-align: center;
}
.list-group-item{
  margin-bottom: 5px;
  height: 105px;
  padding: 0px;
  background: #ededed;
  border-radius: 0px;
}
.labelListImage {
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 0px !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: rgba(255,255,255,0.7);
}
.div-extension-img{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: #238AE6;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    box-shadow: 0px 0px 7px -2px rgb(0 0 0 / 30%);
}

.div-extension-img label {
    font-size: 10px;
    margin: 0px !important;
    display: block;
    color: #fff;
    font-weight: bold;
}
/* end popup image */

/* style for upload area */
#imgPrincipal[type="file"] {
  display: none;
}
#imgBanner[type="file"] {
  display: none;
}
.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  border: 3px dashed #ededed;
  border-radius: 10px;
}
/* end style for upload area */
.previewImageExistFolder {
  max-width: 100%;
  max-height: 150px;
}
.contPreviewImageExistFolder {
  padding: 15px;
  margin: 2px;
  border: 2px solid #ededed;
  cursor: pointer;
}
container-fluid label {
    margin-bottom: 0px;
    font-weight: 100!important;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
    color: #444;
    line-height: 28px;
    font-size: 16px!important;
}

</style>
